import L from 'leaflet';

export const southWest = L.latLng(85, -180),
  northEast = L.latLng(-85, 180),
  maxBounds = L.latLngBounds(southWest, northEast);
